import React, { useEffect, useState } from 'react';
import { ChatExpandedDrawer } from '@/components/team-chat/ChatExpandedDrawer';
import { NewChatModal } from '@/components/team-chat/NewChatModal';
import { useTeamChatStore } from '@/lib/stores/teamChatStore';
import { useWhatsAppDrawerStore } from '@/lib/stores/whatsappDrawerStore';

interface TeamChatPaneProps {
  onClose: () => void;
}

/**
 * Scheda "Team" del drawer Messaggi: innesta il pannello della chat di team
 * (ChatExpandedDrawer, che nasce come drawer fisso a destra) dentro l'area del
 * drawer unico. Le regole CSS del wrapper neutralizzano posizionamento fisso,
 * larghezza e scorrimento del pannello; lista e thread restano quelli suoi.
 */
export function TeamChatPane({ onClose }: TeamChatPaneProps) {
  const [showNewChat, setShowNewChat] = useState(false);
  const pendingChatId = useWhatsAppDrawerStore((s) => s.pendingTeamChatId);
  const clearPendingTeamChat = useWhatsAppDrawerStore((s) => s.clearPendingTeamChat);
  const selectChat = useTeamChatStore((s) => s.selectChat);
  const chats = useTeamChatStore((s) => s.chats);

  // Apertura mirata (riga della vista "Tutte", notifica): seleziona appena la chat c'e'.
  useEffect(() => {
    if (!pendingChatId) return;
    if (chats.some((c) => c.id === pendingChatId)) {
      void selectChat(pendingChatId);
      clearPendingTeamChat();
    }
  }, [pendingChatId, chats, selectChat, clearPendingTeamChat]);

  return (
    <div className="flex-1 min-h-0 relative overflow-hidden [&>div:first-child]:!static [&>div:first-child]:!w-full [&>div:first-child]:!h-full [&>div:first-child]:!translate-x-0 [&>div:first-child]:!z-auto">
      <ChatExpandedDrawer isOpen onClose={onClose} onNewChat={() => setShowNewChat(true)} />
      <NewChatModal isOpen={showNewChat} onClose={() => setShowNewChat(false)} />
    </div>
  );
}
